import { Create, ListButton, TopToolbar } from 'react-admin';

import ChevronLeft from '@material-ui/icons/ChevronLeft';

import EconomicActivityForm from './EconomicActivityForm';

const EconomicActivityActions = ({ basePath }: any) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const EconomicActivityCreate = (props: any) => {
  return (
    <Create actions={<EconomicActivityActions {...props} />} {...props}>
      <EconomicActivityForm />
    </Create>
  );
};

export default EconomicActivityCreate;
